// 客户端rem设置插件
export default defineNuxtPlugin(() => {
	// 只在客户端运行
	if (process.client) {
		const baseFontSizePc = 192;
		const baseFontSizeMobile = 37.5;
		const baseWidthPc = 1920;
		const baseWidthMobile = 375;

		function setRemSize() {
			const clientWidth = document.documentElement.clientWidth || window.innerWidth;
			let rem = 192;
			
			if (clientWidth != baseWidthPc) {
				rem = (clientWidth / baseWidthPc) * baseFontSizePc;
			}
			
			if (rem < 120 && rem > 76.8) {
				rem = 120;
			}
			
			if (rem <= 76.8) {
				rem = (clientWidth / baseWidthMobile) * baseFontSizeMobile * (192 / 37.5);
			}
			
			document.documentElement.style.fontSize = rem + 'px';
		}

		// 立即执行
		setRemSize();

		// 监听窗口大小变化
		window.addEventListener('resize', setRemSize);
		
		// 提供全局方法
		window.pxToRem = (px: number) => {
			return px / 192;
		};
	}
}); 